import BlockActionApiTransformer from "./BlockActionApiTransformer";
import BlockActionConditionTranformer from "./BlockActionConditionTranformer";
import BlockActionExtractTransformer from "./BlockActionExtractTransformer";
import BlockActionRedirectionTransformer from "./BlockActionRedirectionTransformer";
import BlockActionTransformer from "./BlockActionTransformer";
import BlockScenarioTransformer from "./BlockScenarioTransformer";
import BlockActionVariableTransformer from "./BlockActionVariableTransformer";
import BlockStatementTransformer from "./BlockStatementTransformer";
import BlockJumpTransformer from "./BlockJumpTransformer";
import BlockAnnouncementTransformer from "./BlockAnnouncementTransformer";
import BlockActionFunctionTransformer from "./BlockActionFunctionTransformer";
import BlockActionCategorizationTransformer from "./BlockActionCategorizationTransformer";


// Block list helper to call transformers easialy

export default {
    api : BlockActionApiTransformer,
    condition : BlockActionConditionTranformer,
    extract_data : BlockActionExtractTransformer,
    keyword_redirection : BlockActionRedirectionTransformer,
    set_var : BlockActionVariableTransformer,
    action : BlockActionTransformer,
    scenario : BlockScenarioTransformer,
    propos : BlockStatementTransformer,
    magic : BlockJumpTransformer,
    announcement : BlockAnnouncementTransformer,
    function : BlockActionFunctionTransformer,
    categorization : BlockActionCategorizationTransformer,
}